import type { ReactNode } from 'react';
import { SEOHead } from '@/components/shared/SEOHead';
import type { PageSeo } from '@/lib/seo';

interface PageLayoutProps {
  seo: PageSeo;
  children: ReactNode;
  /** Tailwind classes for the wrapping <main> — lets pages customize padding/bg */
  className?: string;
}

/**
 * Standard page wrapper — injects <SEOHead> and provides the main landmark.
 * Navbar/Footer/CookieConsent/WhatsAppFloat live at the App shell level
 * (see src/app/App.tsx), not here, so they never re-mount on route changes.
 */
export function PageLayout({ seo, children, className = '' }: PageLayoutProps) {
  return (
    <>
      <SEOHead seo={seo} />
      <main id="main-content" className={className}>
        {children}
      </main>
    </>
  );
}
